import React, { useEffect, useState } from 'react'
import styled from '../assets/css/sidebar.module.css'
import { useLocation, NavLink, Link } from 'react-router-dom';
import Accordion from 'react-bootstrap/Accordion';
import { MdMenu, MdSupportAgent } from "react-icons/md";
import { IoClose } from "react-icons/io5";
import Images from '../assets/images/images';
import { FaExchangeAlt, FaUser } from "react-icons/fa";
import { useSelector } from 'react-redux';
import { RiAdminLine, RiUserVoiceFill } from "react-icons/ri";
import { IoMdChatbubbles } from "react-icons/io";
import { PiHandDepositFill, PiWebhooksLogoBold } from "react-icons/pi";
import { PiHandWithdrawFill } from "react-icons/pi";
import { FaHeadset } from 'react-icons/fa6';

function Sidebar(props) {
  const location = useLocation();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [mbmenu, setMbmenu] = useState(false);

  const [sidemenu, setSidemenu] = useState([])

  const Wallet_Details = useSelector((state) => state.wallet_detail)
  console.log('Wallet_Detailasas---->', Wallet_Details);
  useEffect(() => {
    const handleWindowResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  });
  useEffect(() => {
    if (props.menustate) {
      setMbmenu(props.menustate)
    }
  }, [props.menustate])

  useEffect(() => {
    settingSideRoute()
  }, [Wallet_Details])

  const getRoutes = (route) => {
    switch (route) {
      case "Support Ticket":
        return {
          label: "Support Ticket",
          icon: <RiUserVoiceFill />,
          path: "/supportticketlist",
        }

      case "Chat":
        return {
          label: "Chat",
          icon: <IoMdChatbubbles />,
          path: "/chatlist",
        }

      case "Deposit support ticket":
        return {
          label: "Deposit support",
          icon: <PiHandDepositFill />,
          path: "/depositsupportlist",
        }
      case "Withdraw support ticket":
        return {
          label: "Withdraw support",
          icon: <PiHandWithdrawFill />,
          path: "/withdrawsupportlist",
        }
      case "ReActive Support":
        return {
          label: "ReActive Support",
          icon: <MdSupportAgent  />,
          path: "/reactivatelist",
        }
      case "Name change request":
        return {
          label: "Name change request",
          icon: <FaExchangeAlt />,
          path: "/namechangerequestlist",
        }
      case "Webhooks":
        return {
          label: "Webhooks",
          icon: <PiWebhooksLogoBold />,
          path: "/webhook",
        }
      case "Kyc Settings":
        return {
          label: "Kyc Settings",
          icon: <FaHeadset />,
          path: "/kycsetting",
        }
      case "Kyc Field Settings":
        return {
          label: "Kyc Field Settings",
          icon: <FaHeadset />,
          path: "/kycfieldsetting",
        }
      case "Admin":
        return {
          label: "Admin",
          icon: <RiAdminLine />,
          path: "/adminlist",
        }
        case "Subscriber List":
        return {
          label: "Subscriber List",
          icon: <FaUser />,
          path: "/subscriberlist",
        }
      default :
      return {
        label: "Not a route",
        icon: <FaUser />,
        path: "#",
      }
    }
  }

  const settingSideRoute = () => {
    let route = [
      {
        label: "Users",
        icon: <FaUser />,
        path: "/users",
      }
    ]

    if (Wallet_Details?.payload?.Role == "superadmin") {
      route = [
        ...route,
        {
          label: "Support Ticket",
          icon: <RiUserVoiceFill />,
          path: "/supportticketlist",
        },
        {
          label: "Chat",
          icon: <IoMdChatbubbles />,
          path: "/chatlist",
        },
        {
          label: "Deposit support",
          icon: <PiHandDepositFill />,
          path: "/depositsupportlist",
        },
        {
          label: "Withdraw support",
          icon: <PiHandWithdrawFill />,
          path: "/withdrawsupportlist",
        },
        {
          label: "ReActive Support",
          icon: <MdSupportAgent />,
          path: "/reactivatelist",
        },
        {
          label: "Name change request",
          icon: <FaExchangeAlt  />,
          path: "/namechangerequestlist",
        },
        {
          label: "Webhooks",
          icon: <PiWebhooksLogoBold />,
          path: "/webhook",
        },
        {
          label: "Kyc Settings",
          icon: <FaHeadset />,
          path: "/kycsetting",
        },
        {
          label: "Kyc Field Settings",
          icon: <FaHeadset />,
          path: "/kycfieldsetting",
        },
        {
          label: "Admin",
          icon: <RiAdminLine />,
          path: "/adminlist",
        },
        {
          label: "Subscriber List",
          icon: <FaUser />,
          path: "/subscriberlist",
        }
      ]
    } else {
      if (Wallet_Details?.payload?.Permission?.supportticket) route.push(getRoutes("Support Ticket"));
      if (Wallet_Details?.payload?.Permission?.chat) route.push(getRoutes("Chat"));
      if (Wallet_Details?.payload?.Permission?.depositsupport) route.push(getRoutes("Deposit support ticket"));
      if (Wallet_Details?.payload?.Permission?.withdrawsupport) route.push(getRoutes("Withdraw support ticket"));
      if (Wallet_Details?.payload?.Permission?.reactivate) route.push(getRoutes("ReActive Support"));
      if (Wallet_Details?.payload?.Permission?.namechange) route.push(getRoutes("Name change request"));
      if (Wallet_Details?.payload?.Permission?.webhook) route.push(getRoutes("Webhooks"));
      if (Wallet_Details?.payload?.Permission?.kycsetting) route.push(getRoutes("Kyc Settings"));
      if (Wallet_Details?.payload?.Permission?.kycfieldsetting) route.push(getRoutes("Kyc Field Settings"));
      if (Wallet_Details?.payload?.Permission?.admin) route.push(getRoutes("Admin"));
    }
    console.log('route---->', route);
    setSidemenu(route)
  }
  const closefun = () => {
    setMbmenu(false);
    props.handlemenuopen(false)
  }
  return (
    <>
      {/* <div className={`d-block d-xl-none ${styled.menubar}`}>
        <MdMenu onClick={() => setMbmenu(true)} />
      </div> */}
      <div className={windowWidth > 1199 ? `${styled.sidebarsec}` : mbmenu ? `${styled.sidebarsec} ${styled.mobilemenu} ${styled.mobilemenuopen}` : `${styled.sidebarsec} ${styled.mobilemenu}`}>
        <div className={`d-block d-xl-none ${styled.closeicons}`}>
          <IoClose onClick={closefun} />
        </div>
        <div className={`${styled.siderow}`}>

          <div className={`${styled.menulist}`}>
            <ul className={`${styled.ulstyle}`}>

              {sidemenu.map((e, i) => (
                <li><NavLink title={e.label} to={e.path}><div><span className={`${styled.iconimg}`}>{e.icon}</span></div>{e.label}</NavLink></li>

              ))}
            </ul>


          </div>

        </div>

      </div>
    </>
  )
}

export default Sidebar